import { z } from 'zod';
import { legalClientSchema } from './ILegalClient';

// Zod-Schema für ISendDocumentDocumentType (englische Werte)
export const ISendDocumentDocumentTypeSchema = z.enum([
  'Record',
  'Invoice',
  'Drafts',
  'DocumentsFromRequirements',
  'EmailsFromRequirements',
  'SideFile',
]);

// Zod-Schema für ISendDocumentSendOption (englische Werte)
export const ISendDocumentSendOptionSchema = z.enum([
  'Email',
  'Documentportal',
]);

// Zod-Schema für ISendDocumentNew mit Defaults (entspricht initSendDocumentNew)
export const ISendDocumentNewSchema = z.object({
  legalClientArray: z.array(legalClientSchema).default([]),
  documentTypeArray: z.array(ISendDocumentDocumentTypeSchema).default([]),
  emailText: z.string().optional().default(''),
  subject: z.string().default(''),
  sendOption: ISendDocumentSendOptionSchema.default('Documentportal'),
  idLegalTransaction: z.number(), // Hier muss der Wert zwingend übergeben werden
  selectedDocuments: z.array(z.any()).default([]),
});

export const SendOption = {
  Email: 'Email',
  Documentportal: 'Documentportal',
} as const;

export type ISendDocumentNewSendOption = keyof typeof SendOption;

export type ISendDocumentNew = z.infer<typeof ISendDocumentNewSchema>;

export const initSendDocumentNew = (
  legalTransactionId: number
): ISendDocumentNew =>
  ISendDocumentNewSchema.parse({ idLegalTransaction: legalTransactionId });
